<template>
  <div class="join">
    <!--导航栏-->
    <header-nav></header-nav>
    <div class="join-content">
      <!--轮播图-->
      <div class="banner-box" :style="`background-image: url('${IMG_URL}images/join/banner.png')`"></div>
      <!--产品优势-->
      <div class="join-advantage">
        <img class="advantage-bg" :src="IMG_URL+'/images/join/advantage.png'" alt="">
      </div>
      <!--开通步骤-->
      <div class="join-step" :style="`background-image: url('${IMG_URL}images/join/step_bg.png');`"></div>

      <!--联系我们-->
      <!-- <div class="contact">
        <div class="contact-top">
          <img class="title-img" :src="IMG_URL+'images/join/contactus.png'" alt="">
        </div>
        <div class="contact-content">
          <div class="contact-content-left" :style="`background-image: url('${IMG_URL}images/join/contact_bg.png')`"></div>
          <div class="contact-content-right">
            <div class="contact-form">
              <div class="form-item">
                <span class="form-item-key">姓名：</span>
                <el-input type="text" placeholder="请输入姓名" v-model="param.name"></el-input>
              </div>
              <div class="form-item">
                <span class="form-item-key">电话：</span>
                <el-input type="text" placeholder="请输入电话" v-model="param.phone"></el-input>
              </div>
            </div>
            <div class="contact-form">
              <div class="form-item">
                <span class="form-item-key">微信：</span>
                <el-input type="text" placeholder="请输入微信" v-model="param.wechat"></el-input>
              </div>
              <div class="form-item">
                <span class="form-item-key">邮箱：</span>
                <el-input type="text" placeholder="请输入邮箱" v-model="param.email"></el-input>
              </div>
            </div>
            <div class="contact-form">
              <div class="form-item-2">
                <span class="form-item-key">留言：</span>
                <el-input
                    class="form-textarea"
                    type="textarea"
                    :autosize="{ minRows: 7}"
                    placeholder="请输入内容"
                    v-model="param.content">
                </el-input>
              </div>
            </div>
            <div class="contact-form noSelect">
              <div class="submit-btn" @click="onSubmitJoin">提交</div>
            </div>
            </div>
        </div> 
      </div> -->
    </div>
    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import footerBox from "@/components/footerBox/index"
import {apiManyStoreContact} from "@/api/api"
export default {
  name: "product",
  components:{headerNav, footerBox},
  data(){
    return{
      param: {
        qq: "",
        name: "",
        phone: "",
        wechat: "",
        email: "",
        content: ""
      },
      is_submit: false,
    }
  },
  methods: {
    onSubmitJoin(){
      if(!this.param.name){
        this.$message.info("请输入您的姓名");
        return;
      }
      if(!this.param.phone){
        this.$message.info("请输入您的手机号码");
        return;
      }
      if(!this.param.content){
        this.$message.info("请输入留言内容");
        return;
      }
      if(this.is_submit) return;
      this.is_submit = true;
      apiManyStoreContact(this.param).then(res => {
        if(res.code === 1){
          this.is_submit = false;
          this.$message.success("提交成功，我们会尽快联系到您！")
          this.param = {
            qq: "",
            name: "",
            phone: "",
            wechat: "",
            email: "",
            content: ""
          }
        }else{
          this.is_submit = false;
        }
      }).catch(error => {
        this.is_submit = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.join{
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #ffffff;

  .join-content{
    min-width: 1300px;

    .banner-box{
      width: 100%;
      height: 500px;
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 100% auto
    }
    .join-advantage{
      text-align: center;
      margin-top: 30px;
      margin-bottom: 80px;

      .advantage-bg{
        width: auto;
        height: 500px;
      }
    }

    .join-step{
      width: 100%;
      height: 880px;
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 100% auto
    }

  }

  .contact{
    margin: 40px 0;

    .contact-top{
      text-align: center;

      .title-img{
        height: 45px;
        width: auto;
      }
    }
    .contact-content{
      width: 1300px;
      margin: 60px auto 0;
      display: flex;
      justify-content: space-between;

      .contact-content-left{
        width: 537px;
        height: 322px;
        background-position: top center;
        background-repeat: no-repeat;
        background-size: 100% auto
      }
      .contact-content-right{
        flex: 1;
        margin-left: 30px;

        .contact-form{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .form-item{
            width: 50%;
            display: flex;
            align-items: center;
            margin-right: 30px;

            .form-item-key{
              font-size: 14px;
              font-weight: bold;
              width: 80px;
            }
          }
          .form-item-2{
            display: flex;
            align-items: center;
            margin-right: 30px;
            width: 100%;

            .form-item-key{
              font-size: 14px;
              font-weight: bold;
              width: 70px;
            }
          }
          .submit-btn{
            width: 90px;
            height: 40px;
            background-color: #0f375a;
            color: #fff;
            font-size: 14px;
            text-align: center;
            line-height: 40px;
            margin-left: 64px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/join/index.vue